import { useSyncExternalStore } from "react"

/**
 * Whether a media query matches, kept current as the window changes.
 *
 * An external store rather than state set in an effect, so the answer is right on the first client
 * render rather than one render late — nothing is drawn once for the wrong width and then redrawn.
 * On the server, where there is no window, it does not match.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query)
      list.addEventListener("change", onChange)
      return () => list.removeEventListener("change", onChange)
    },
    () => window.matchMedia(query).matches,
    () => false,
  )
}

/** Below Tailwind's `sm` breakpoint: a phone held upright. */
export const PHONE_QUERY = "(max-width: 639px)"
